import { CodeVerification, Preloader, Button } from 'account-ui-components'
import { ref, reactive, onMounted } from 'vue'
import Api from '@/api'
import Stepper from '@/uikit/Stepper/Stepper.vue'
import Page from '@/components/Page/Page.vue'
import questionMarkIcon from '@/assets/img/questionmark.svg'

const ForgotPasswordConfirmation = {
  name: 'ForgotPasswordConfirmation',

  components: {
    Button,
    Stepper,
    Page,
    CodeVerification,
    Preloader
  },

  setup() {
    const images = {
      questionMark: questionMarkIcon
    }
    const antiForgeryToken = ref(null)
    const email = ref('')
    const loading = reactive({
      component: false,
      confirm: false,
      resend: false
    })
    const errors = reactive({
      code: ''
    })
    const mfaEnabled = ref(false)
    const lockout = ref(false)
    const timeLeft = ref(0)
    const error = ref('')
    const antiForgeryField = document.querySelector('input[name=__RequestVerificationToken]')

    if (antiForgeryField) {
      antiForgeryToken.value = antiForgeryField.value
    }

    onMounted(() => {
      const storageEmail = localStorage.getItem('email')

      if (storageEmail) {
        email.value = storageEmail
      }
    })

    const startCountdown = () => {
      const timer = setInterval(() => {
        if (timeLeft.value > 0) {
          timeLeft.value -= 1
        } else {
          clearInterval(timer)
        }
      }, 1000)
    }

    const onVerifyConfirm = async (code) => {
      loading.confirm = true

      try {
        await Api.verifyForgotPasswordCode(email.value, code)

        window.location.href = `/account/resetpassword?email=${email.value}&code=${code}`

        localStorage.removeItem('email')
      } catch (err) {
        if (err.response.status === 429) {
          lockout.value = true
          timeLeft.value = 30
          errors.code = 'Incorrect code. Request a new code and try again.'
          startCountdown()
        } else if (err.response.data.includes('The code is expired')) {
          lockout.value = true
          errors.code = 'The code is expired. Request a new code and try again.'
        } else {
          errors.code = 'Incorrect code. Enter the code again.'
        }
      }
      loading.confirm = false
    }

    const onSendNewCode = async (event) => {
      loading.resend = true
      await Api.sendNewCode(email.value, antiForgeryToken.value)
      lockout.value = false
      loading.resend = false
      error.value = ''
      event.preventDefault()
    }

    const clearCodeVerificationError = () => {
      if (errors.code) {
        errors.code = ''
      }
    }

    return {
      images,
      email,
      lockout,
      timeLeft,
      error,
      loading,
      antiForgeryToken,
      errors,
      mfaEnabled,
      onVerifyConfirm,
      onSendNewCode,
      clearCodeVerificationError
    }
  }
}

export default ForgotPasswordConfirmation
